export default {
    sDecimal: '',
    sEmptyTable: 'No data available in table',
    sInfo: 'Showing _START_ to _END_ of _TOTAL_ entries',
    sInfoEmpty: 'Showing 0 to 0 of 0 entries',
    sInfoFiltered: '(filtered from _MAX_ total entries)',
    sInfoPostFix: '',
    sThousands: ',',
    sLengthMenu: 'Show _MENU_ entries',
    sLoadingRecords: 'Loading...',
    sProcessing: 'Loading...',
    sSearch: 'Search:',
    sZeroRecords: 'No matching records found',
    oPaginate: {
        sFirst: 'First',
        sLast: 'Last',
        sNext: 'Next',
        sPrevious: 'Previous'
    },
    oAria: {
        sSortAscending: ': activate to sort column ascending',
        sSortDescending: ': activate to sort column descending'
    }
};